export default __webpack_public_path__ + "98a96b1deac7131c9e72b973ccd7be3f.ico";